import React from 'react';
import {
  PassiveBonuses as PassiveBonusesData, PassiveAbilityDefinition,
  findPassiveDefinition, humanizeEffectKey, formatBonusValue,
} from '../types/skillTree';

interface Props {
  passiveBonuses: PassiveBonusesData;
  passiveDefinitions: PassiveAbilityDefinition[];
}

const PassiveBonuses: React.FC<Props> = ({ passiveBonuses, passiveDefinitions }) => {
  const hasStatBonuses = Object.values(passiveBonuses.statBonuses).some(v => v > 0);
  const hasCombatBonuses = Object.values(passiveBonuses.combatBonuses).some(v => v > 0);

  return (
    <div className="passive-bonuses-section">
      <div className="passive-bonuses-title">Passive Bonuses</div>

      {hasStatBonuses && (
        <>
          <div className="skill-effects-title">Stat Bonuses:</div>
          <div className="stat-bonuses-grid">
            {Object.entries(passiveBonuses.statBonuses).map(([stat, value]) =>
              value > 0 && (
                <div key={stat} className="stat-bonus-item">
                  <span className="stat-bonus-label">{humanizeEffectKey(stat)}:</span>
                  <span className="stat-bonus-value">+{value}</span>
                </div>
              )
            )}
          </div>
        </>
      )}

      {hasCombatBonuses && (
        <>
          <div className="skill-effects-title">Combat Bonuses:</div>
          <div className="stat-bonuses-grid">
            {Object.entries(passiveBonuses.combatBonuses).map(([bonus, value]) =>
              value > 0 && (
                <div key={bonus} className="stat-bonus-item">
                  <span className="stat-bonus-label">{humanizeEffectKey(bonus)}:</span>
                  <span className="stat-bonus-value">{formatBonusValue(bonus, value)}</span>
                </div>
              )
            )}
          </div>
        </>
      )}

      {passiveBonuses.passiveAbilities.length > 0 && (
        <div className="passive-abilities-list">
          <div className="passive-abilities-title">Passive Abilities:</div>
          {passiveBonuses.passiveAbilities.map(ability => {
            const definition = findPassiveDefinition(passiveDefinitions, ability);
            return (
              <div key={ability} className="passive-ability-item" title={definition?.description}>
                {definition?.name ?? ability}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PassiveBonuses;
